import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import TV from '@/helpers/TV';
import Device from '@/helpers/Device';
import DeviceFingerprint from '@/helpers/fingerprint';
import router from '@/router';
import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
    deviceId: null,
    buildingId: null,
    groupId: null,
    type: this.getDeviceType,
    agent: this.getUserAgent,
    updated: Math.floor(new Date().getTime() / 1000),
    model: this.getDeviceModel,
    version: this.getDeviceVersion,
    software: this.getSoftware,
    mac: this.getMAC,
    ip: this.getIP,
    serialNumber: this.getSerial,
    platform: this.getPlatform,
    resHeight: this.getResolutionHeight,
    resWidth: this.getResolutionWidth,
    isDeviceLoaded: false,
    roomApps: {
      "ident" : [],
    },
  }),
  mutations: {
    setValues(state, context) {
      for (const item in context) {
        Vue.set(state, item, context[item]);
        // state[item] = context[item];
      }
    },
    setDeviceLoaded(state, value = true) {
      state.isDeviceLoaded = value;
    },
  },
  actions: {
    async init({ commit, dispatch, state }) {
      if (state.isDeviceLoaded) return Promise.resolve('Already loaded');
      const savedData = Registration.getData;
      if (savedData.deviceId) {
        try {
          const resHeight = Device.resolutionHeight;
          const resWidth = Device.resolutionWidth;
          const [serialNumber, mac, ip, response, currentFingerprint] = await Promise.all([
            Device.serialNumber,
            Device.mac,
            Device.ip,
            Requests.fetchDeviceInfo({
              deviceId: savedData.deviceId,
              bid: savedData.bid,
            }),
            new DeviceFingerprint().generateFingerprint(),
          ]);

          // Fingerprint-Abgleich: nur wenn API-Geraet bereits einen Fingerprint hat
          if (response.fingerprint) {
            if (response.fingerprint === currentFingerprint) {
              console.log('[Device] Fingerprint OK:', currentFingerprint);
            } else {
              console.warn('[Device] Fingerprint mismatch! API:', response.fingerprint, 'TV:', currentFingerprint);
            }
          } else {
            // Altes Geraet ohne Fingerprint → normal weitermachen
            console.log('[Device] Kein Fingerprint in API (altes Geraet) - weiter');
          }

          const mergedData = { ...savedData, ...response, resHeight, resWidth, serialNumber, mac, ip };
          console.log('RESPONSE DEVICE', response, savedData, mergedData);

          await dispatch('saveDeviceData', mergedData);
          commit('setDeviceLoaded');
          return Promise.resolve();
        } catch (err) {
          console.log('eerr', err);
          // router.push({ name: 'Registration' });
          return Promise.reject();
        }
      } else {
        // Kein deviceId gespeichert → Fingerprint-Lookup versuchen
        try {
          const fingerprint = await new DeviceFingerprint().generateFingerprint();
          const existingDevice = await Requests.fetchDeviceByFingerprint(fingerprint);
          if (existingDevice && existingDevice.id) {
            console.log('[Device] Geraet per Fingerprint wiedergefunden:', existingDevice.id);
            await Registration.saveData({
              deviceId: existingDevice.id,
              bid: existingDevice.buildingId,
              room: existingDevice.room,
              serialNumber: existingDevice.serialNumber,
            });
            const mergedData = {
              ...existingDevice,
              resHeight: Device.resolutionHeight,
              resWidth: Device.resolutionWidth,
            };
            await dispatch('saveDeviceData', mergedData);
            commit('setDeviceLoaded');
            return Promise.resolve();
          }
        } catch (err) {
          console.log('[Device] Fingerprint-Lookup fehlgeschlagen:', err);
        }
        return Promise.reject();
      }
    },
    update({ commit, dispatch }) {
      commit('setDeviceLoaded', false);
      dispatch('init');
    },
    async saveDeviceData({ commit, dispatch }, context) {
      commit('setValues', context);

      dispatch(
        'initGlobalValues',
        {
          buildingId: context.buildingId,
          deviceId: context.deviceId,
          groupId: context.groupId,
        },
        { root: true }
      );
      return Promise.resolve();
    },
    turnOff() {
      if (router.currentRoute.name !== 'Home') {
        router.push('/');
      }
      Device.turnOff();
    },
    turnOn() {
      Device.turnOn();
    },
    reboot() {
      Device.reboot();
    },
  },
  getters: {
    getHasTVPackageAssigned(state) {
      const packages = state['tv-packages'];
      if (!packages) return false;
      if (packages.ident === '') return false;
      return true;
    },
    getTVPackageName(state, getters) {
      if (!getters.getHasTVPackageAssigned) return '';
      return state['tv-packages'].ident;
    },
    getRoomAppInDevice(state, getters) {
      if(typeof state.roomApps === 'undefined' || typeof state.roomApps.ident === 'undefined') {
        return [];
      }
      return state.roomApps.ident;
    },
    getDevice(state, getters) {
      return this.state;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/device.js